import React, { Component } from 'react';
import InnerSlider from "react-slick";
import '../solution.scss';

class MBMESoftware extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }
    next() {
        this.slider.slickNext();
    }
    previous() {
        this.slider.slickPrev();
    }

    hadleButtonClick(event) {
        this.props.parentTabCallback(event);
    }
    render() {
        const settings = {
            dots: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            speed: 2000,
            autoplaySpeed: 2000,
            cssEase: "linear",
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        return (
            <div className="tabData">
                <div className="each-block">
                    <h4 className="head-medium-block">MBMEPAY SOFTWARE</h4>
                    <span className="content"> Get Complete Customized Software With Our Smart Solutions </span>
                    <p className="content my-4">
                    From software application to UX/UI design and creating turnkey solutions - with our vast industry experience, we’re able to provide streamlined self-service solutions with an array of varying elements to ensure a seamless kiosk experience for our clients.</p>
                    <p className="content">
                    Our experience across various sectors allows our experts to design and implement these bespoke solutions in a diverse range of industries. With a unique and efficient approach, our software developers are well-versed with international standards, PCI compliance, and strict security protocols.
                    </p>
                    <p className="content">
                    <h5 className="head-medium-block">Our Software Process</h5>
                    <ol>
                    <li>Evaluation - Our experts evaluate your needs with careful workflow and expectation modeling.</li>
                    <li>Mapping - We map out your requirements and design custom, effective, and high-quality solutions. </li>
                    <li>Implementation - With meticulous time management, a project scope, and close collaboration with you, we implement your customized software. </li>
                    </ol>
                    </p>

                </div>

                <div className="each-block field-padd-3 sf">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h4 className="head-medium-block">SOFTWARE FEATURES</h4>
                            <span className="content"> All that you need </span>
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                            <span className="slickbtn" onClick={this.previous}>
                                <i className="arrow left"></i>
                            </span>
                            <span className="slickbtn" onClick={this.next}>
                                <i className="arrow right"></i>
                            </span>
                        </div>
                    </div>



                    <div className="mbme-slidr">
                        <InnerSlider ref={c => (this.slider = c)} {...settings}>
                            <div className="card-block">
                                <div className="each-card-block software-block">
                                    <h4 className="head-medium-normal mt-0 mb-3">Kiosk management</h4>
                                    <p className="content"> Get the flexibility of multiple controls and reports to manage large node kiosk estates - all backed up by EMV, PCI, and PCI-DSS approvals.</p>
                                    <p className="content"> Access an extensive range of management information reports that are readily at your disposal whenever you need them.</p>
                                </div>
                            </div>
                            <div className="card-block">
                                <div className="each-card-block software-block">
                                    <h4 className="head-medium-normal mt-0 mb-3">Monitoring</h4>
                                    <p className="content"> Each individual kiosk is connected to Kiosk Studio which remotely monitors the system in real-time. What’s more, if there are ever any technical difficulties, you’ll have instant technical support from our regional support centers.</p>
                                    <p className="content"> Our priority is to ensure operational efficiency for you and your business, which is why our dedicated team is here to ensure you’re always taken care of.</p>
                                </div>
                            </div>
                            <div className="card-block">
                                <div className="each-card-block software-block">
                                    <h4 className="head-medium-normal mt-0 mb-3">Transactional and <br /> revenue reports</h4>
                                    <p className="content"> Track your commercial performance in real-time with statistical reporting and detailed financial analysis from all services and kiosks.</p>
                                    <p className="content"> All protected by secure login systems </p>
                                </div>
                            </div>
                            <div className="card-block">
                                <div className="each-card-block software-block">
                                    <h4 className="head-medium-normal mt-0 mb-3">Performance reports</h4>
                                    <p className="content">Detailed performance reports are auto-generated and are available on-demand.</p>
                                    <p className="content"> Get instant access to data-mined services to get important reports that include</p>
                                    <div className="styled-ul">
                                        <span className="content dot">Individual hardware statuses</span>
                                        <span className="content dot">Hardware faults</span>
                                        <span className="content dot">Consumable monitoring</span>
                                        <span className="content dot">Kiosk availability</span>
                                        <span className="content dot">Network performances</span>
                                    </div>
                                </div>
                            </div>
                        </InnerSlider>
                    </div>
                </div>
            </div>
        );
    }
}

export default MBMESoftware;
